<script>
import { detectOS } from "@/common/util";
import saveSystemLog from "@/common/saveLog";
const packageJSON = require("root/package.json");

export default {
  props: {
    item: Object,
    showEdit: Boolean
  },
  data() {
    const videoUrl = "";
    return {
      videoDialog: false,
      videoUrl,
      editDialog: false,
      EditForm: {
        principle: undefined,
        descriptionWeb: undefined,
        name: undefined,
        descriptionPad: undefined
      },
      delayLoadTop: 0
    };
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    }
  },
  methods: {
    clickVideo() {
      this.videoDialog = true;
      this.videoUrl = this.item.videoUrl;
      let that = this;
      this.$nextTick(() => {
        var elevideo = document.getElementsByClassName("video")[0];
        //监听视频开始加载完成，重新计算到顶高度
        if (elevideo) {
          elevideo.addEventListener("loadedmetadata", function() {
            that.$refs.videoDialog.marginAdjust();
          });
        }
      });
    },
    hideVideo() {
      this.videoDialog = false;
      this.videoUrl = "";
    },
    onClickEdit() {
      this.editDialog = true;
      this.EditForm = {
        name: this.item.name,
        principle: this.item.principle,
        descriptionWeb: this.item.descriptionWeb,
        descriptionPad: this.item.descriptionPad
      };
    },
    saveEdit() {
      const data = this.EditForm;
      data.gameId = this.item.id;
      this.$emit("saveEditResult", data);
      this.hideEdit();
    },
    hideEdit() {
      this.editDialog = false;
      this.EditForm = {
        principle: undefined,
        descriptionWeb: undefined,
        name: undefined,
        descriptionPad: undefined
      };
    }
  }
};
</script>

<template>
  <div class="gameIntroduceCard">
    <el-row :gutter="24">
      <el-col :span="4" class="cellColCenter">
        <div class="GameCellImg">
          <img class="replayMode" :src="item.icon" />
          <div class="replayImgMode" v-if="item.videoUrl" @click="clickVideo"></div>
          <img class="replayIcon" v-if="item.videoUrl" src="./assets/视频回放.svg" @click="clickVideo" />
        </div>
      </el-col>
      <el-col :span="19">
        <div class="GameCellIntroduce">
          <div class="gameName">
            {{item.name}}
            <span v-if="showEdit" class="editIcon" @click="onClickEdit">
              <i class="el-icon-edit"></i>编辑
            </span>
          </div>
          <div>
            <span>游戏说明Web：</span>
            <span>{{item.descriptionWeb}}</span>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="item.descriptionWeb"
              placement="top-start"
            >
              
            </el-tooltip>-->
          </div>
          <div>
            <span>游戏说明Pad：</span>
            <span>{{item.descriptionPad}}</span>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="item.descriptionWeb"
              placement="top-start"
            >
              
            </el-tooltip>-->
          </div>
          <div>
            <span>原理简介：</span>
            <span>{{item.principle}}</span>
            <!-- <el-tooltip
              class="item"
              effect="dark"
              :content="item.principle"
              placement="top-start"
            >
             
            </el-tooltip>-->
          </div>
        </div>
      </el-col>
    </el-row>

    <operationDialog
      :title="item.name"
      :Visible="videoDialog"
      class="popContainer"
      width="45%"
      @close="hideVideo"
      :hideSave="true"
      :top="delayLoadTop"
      ref="videoDialog"
    >
      <video :src="videoUrl" controls autoplay="autoplay" class="video" width="100%"></video>
    </operationDialog>
    <operationDialog
      title="编辑训练简介"
      :Visible="editDialog"
      class="editDialog"
      width="600px"
      @close="hideEdit"
      :center="true"
      btnText="提交"
      @confirm="saveEdit"
    >
      <el-form ref="EditForm" :model="EditForm" label-width="100px">
        <el-form-item label="训练名称">
          <el-input type="text" v-model="EditForm.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="游戏说明Web">
          <el-input type="textarea" rows="3" v-model="EditForm.descriptionWeb"></el-input>
        </el-form-item>
        <el-form-item label="游戏说明Pad">
          <el-input type="textarea" rows="3" v-model="EditForm.descriptionPad"></el-input>
        </el-form-item>
        <el-form-item label="原理简介">
          <el-input type="textarea" v-model="EditForm.principle"></el-input>
        </el-form-item>
      </el-form>
    </operationDialog>
  </div>
</template>

<style lang="scss">
.gameIntroduceCard {
  // width: 210px;
  // height: 230px;
  padding: 10px;
  border-bottom: 1px solid #f0f0f0;
  min-height: 125px;

  .popContainer {
    .el-dialog {
      background-color: #000000;

      .el-dialog__title {
        color: #ffffff;
      }

      .el-dialog__headerbtn {
        font-size: 25px;
        top: 10px;
        right: 15px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #ffffff;
      }

      .el-dialog__body {
        padding: 0;
      }
    }

    .video {
      // height: 400px;
    }
  }

  .editDialog {
    .el-dialog__body {
      padding-left: 5px;
      padding-bottom: 5px;
      max-height: 350px;
      overflow-y: auto;
    }

    .operationDialog .el-dialog__footer .el-button--primary {
      width: 300px;
    }
  }

  .el-col {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .el-row {
    margin-left: 0px !important;
    margin-right: 0px !important;
  }

  .cellColCenter {
    text-align: center;
  }

  .GameCellImg {
    display: inline-block;
    position: relative;
    width: 150px;
    height: 125px;
    background: #000000;
    // border-radius: 2px;
    // border: 1px solid rgba(233, 233, 233, 1);
    // margin: 25px 0 0 0;
    box-sizing: border-box;
    cursor: pointer;

    img {
      width: 100%;
      margin-top: 15px;
      height: 90px;
    }

    .replayIcon {
      position: relative;
      float: left;
      width: 35px;
      height: 35px;
      margin-top: -70px;
      margin-left: 55px;
    }

    .replayImgMode {
      position: absolute;
      top: 0;
      // left: -2px;
      margin-top: 15px;
      width: 100%;
      height: 90px;
      opacity: 0.6;
      background-color: #000000 !important;
    }
  }

  .GameCellIntroduce {
    // display: inline-block;
    // padding-left: 15px;
    // height: 125px;

    .gameName {
      font-size: 16px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
      margin-bottom: 10px;

      .editIcon {
        float: right;
        font-size: 14px;
        color: #00c1de;
        cursor: pointer;
      }
    }

    > div {
      // display: inline-block;
      color: rgba(0, 0, 0, 0.65);
      margin-bottom: 15px;
      line-height: 20px;
      // text-overflow: -o-ellipsis-lastline;
      // overflow: hidden;
      // text-overflow: ellipsis;
      // display: -webkit-box;
      // -webkit-line-clamp: 2;
      // line-clamp: 2;
      // -webkit-box-orient: vertical;
      // word-break: break-all;
    }
  }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/gameIntroduceCard.vue